module.exports = __webpack_public_path__ + "img/ennetix-report-page3.ad9e31df.png";